// 🔑 Cambios principales:
// - Reemplacé "email" por "correo_electronico"
// - Ajusté handleSearch para filtrar también por apellido y correo_electronico
// - Excel exporta correo_electronico
// - En columnas muestro apellido y correo_electronico correctamente

import React, { useEffect, useState } from 'react';
import {
  Table,
  Space,
  Button,
  Tag,
  Dropdown,
  Menu,
  Input,
  Grid,
  Typography,
  Modal,
  message,
  Tabs
} from 'antd';
import {
  UserOutlined,
  EllipsisOutlined,
  DownloadOutlined
} from '@ant-design/icons';
import axios from 'axios';
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';
import { Link } from 'react-router-dom';
import RegisterFreeUser from './RegisterFreeUser';
import {
  formatCurrency,
  formatPlanLabel,
  getPlanAmount,
} from '../utils/subscriptions';


const { useBreakpoint } = Grid;
const { Search } = Input;
const { Title } = Typography;

const UserCard = ({ user, isAdminSection, onToggleStatus }) => (
  <div className="admin-user-card">
    <div className="admin-user-card-top">
      <div>
        <p className="admin-user-card-name">
          {user.nombre} {user.apellido}
        </p>
        <p className="admin-user-card-mail">{user.correo_electronico}</p>
        {isAdminSection && user.contraseña_visible_admin ? (
          <p className="admin-user-card-meta">Contraseña: {user.contraseña_visible_admin}</p>
        ) : null}
        {!isAdminSection ? (
          <>
            <p className="admin-user-card-meta">Plan: {formatPlanLabel(user.plan)}</p>
            <p className="admin-user-card-meta">Monto: {formatCurrency(getPlanAmount(user.plan))}</p>
          </>
        ) : null}
      </div>
      <Tag color={user.estado === 'activo' ? 'green' : 'red'}>{user.estado?.toUpperCase()}</Tag>
    </div>

    <div className="admin-user-card-actions">
      {isAdminSection ? (
        <Link to={`/admin/user/${user.id}/edit-profile`}>
          <Button>{user.Perfil ? 'Editar perfil' : 'Crear perfil'}</Button>
        </Link>
      ) : null}
      <Link to={`/admin/user/${user.id}`}>
        <Button type="primary">Ver Perfil</Button>
      </Link>
      <Button danger={user.estado === 'activo'} onClick={() => onToggleStatus(user.id, user.estado)}>
        {user.estado === 'activo' ? 'Desactivar' : 'Activar'}
      </Button>
    </div>
  </div>
);

const Usuarios = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const [usuarios, setUsuarios] = useState([]);
  const [usuariosFiltrados, setUsuariosFiltrados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [registerModalOpen, setRegisterModalOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('admin');

  useEffect(() => {
    fetchUsuarios();
  }, []);

  const fetchUsuarios = async () => {
    try {
      setLoading(true);
      const res = await axios.get('https://app-swingervip-production.up.railway.app/api/users');
      setUsuarios(res.data);
      setUsuariosFiltrados(res.data);
    } catch (error) {
      console.error(error);
      Modal.error({
        title: 'Error al cargar usuarios',
        content: error.message,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (value) => {
    const normalizedValue = value.toLowerCase();
    setSearchText(normalizedValue);
    const filtered = usuarios.filter((u) =>
      u.nombre?.toLowerCase().includes(normalizedValue) ||
      u.apellido?.toLowerCase().includes(normalizedValue) ||
      u.correo_electronico?.toLowerCase().includes(normalizedValue) ||
      u.id?.toString().includes(normalizedValue)
    );
    setUsuariosFiltrados(filtered);
  };

  const usuariosAdmin = usuariosFiltrados.filter(
    (usuario) => usuario.registrationSource === 'admin'
  );

  const usuariosSelf = usuariosFiltrados.filter(
    (usuario) => usuario.registrationSource !== 'admin'
  );



  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Usuarios');

    worksheet.columns = [
      { header: 'ID', key: 'id', width: 36 },
      { header: 'Nombre', key: 'nombre', width: 20 },
      { header: 'Apellido', key: 'apellido', width: 20 },
      { header: 'Correo Electrónico', key: 'correo_electronico', width: 30 },
      { header: 'Estado', key: 'estado', width: 15 },
    ];

    usuariosFiltrados.forEach((u) => {
      worksheet.addRow({
        id: u.id,
        nombre: u.nombre,
        apellido: u.apellido,
        correo_electronico: u.correo_electronico,
        estado: u.estado,
      });
    });

    worksheet.getRow(1).eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '000000' },
      };
      cell.font = { color: { argb: 'FFFFFF' }, bold: true };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, 'Usuarios.xlsx');
  };
const actualizarEstado = async (id, estadoActual) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.put(
      `https://app-swingervip-production.up.railway.app/api/users/${id}/estado`,
      {},
      { headers: { Authorization: token } }
    );

    message.success(`Estado actualizado a ${res.data.estado}`);
    fetchUsuarios(); // refresca la tabla
  } catch (error) {
    console.error(error);
    Modal.error({
      title: 'Error al actualizar estado',
      content: error.message,
    });
  }
};

  const mobileMenu = (
    <Menu>
      <Menu.Item key="excel">
        <Button
          type="primary"
          onClick={exportToExcel}
          icon={<DownloadOutlined />}
          block
        >
          Exportar Excel
        </Button>
      </Menu.Item>
    </Menu>
  );

  const columns = [

    {
      title: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre',
    },
    {
      title: 'Apellido',
      dataIndex: 'apellido',
      key: 'apellido',
    },
    {
      title: 'Correo Electrónico',
      dataIndex: 'correo_electronico',
      key: 'correo_electronico',
    },
    {
      title: 'Plan',
      dataIndex: 'plan',
      key: 'plan',
      render: (plan) => formatPlanLabel(plan),
    },
    {
      title: 'Monto',
      dataIndex: 'plan',
      key: 'monto',
      render: (plan) => formatCurrency(getPlanAmount(plan)),
    },
    {
      title: 'Estado',
      dataIndex: 'estado',
      key: 'estado',
      render: (estado) => (
        <Tag color={estado === 'activo' ? 'green' : 'red'}>
          {estado?.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: 'Acciones',
      key: 'acciones',
      render: (_, record) => (
        <Space>
          <Link to={`/admin/user/${record.id}`}>
          <Button
            type="primary"
            >
            Ver Perfil
          </Button>
            </Link>
          <Button
            danger={record.estado === 'activo'}
            onClick={() => actualizarEstado(record.id, record.estado)}
          >
            {record.estado === 'activo' ? 'Desactivar' : 'Activar'}
          </Button>
        </Space>
      ),
    },
  ];

  const adminColumns = [
    ...columns.slice(0, 3),
    {
      title: 'Contraseña',
      dataIndex: 'contraseña_visible_admin',
      key: 'contraseña_visible_admin',
      render: (password) => password || '-',
    },
    {
      title: 'Perfil',
      key: 'perfil_admin',
      render: (_, record) => (
        <Link to={`/admin/user/${record.id}/edit-profile`}>
          <Button>{record.Perfil ? 'Editar perfil' : 'Crear perfil'}</Button>
        </Link>
      ),
    },
    columns[5],
    columns[6],
  ];

  return (
    <div className="admin-page-shell">
      <div
        className="admin-users-header"
        style={{
          padding: isMobile ? '20px 16px 0' : 0,
        }}
      >
        <div className="admin-users-title">
          <UserOutlined style={{ fontSize: 28, color: '#1890ff' }} />
          <Title level={3} style={{ margin: 0 }}>Gestión de Usuarios</Title>
        </div>
        <Space className="admin-users-tools">
          <Button type="primary" onClick={() => setRegisterModalOpen(true)}>
            Registrar usuario gratis
          </Button>
          <Dropdown 
            overlay={mobileMenu} 
            trigger={['click']} 
            visible={dropdownVisible}
            onVisibleChange={setDropdownVisible}
          >
            <Button icon={<EllipsisOutlined />} />
          </Dropdown>
        </Space>
      </div>

      <div
        className="admin-search-wrap"
        style={{ padding: isMobile ? '0 16px' : 0 }}
      >
        <Search
          placeholder="Buscar por nombre, apellido o correo"
          allowClear
          enterButton="Buscar"
          size="large"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onSearch={handleSearch}
          style={{
            width: '100%',
            maxWidth: '600px',
            display: 'block',
            padding: '0 10px',
            boxSizing: 'border-box',
          }}
        />
      </div>

      <Tabs
        activeKey={activeSection}
        onChange={setActiveSection}
        items={[
          {
            key: 'admin',
            label: `Creados por admin (${usuariosAdmin.length})`,
            children: isMobile ? (
              <div className="admin-mobile-list">
                {usuariosAdmin.length ? (
                  usuariosAdmin.map((user) => (
                    <UserCard
                      key={user.id}
                      user={user}
                      isAdminSection
                      onToggleStatus={actualizarEstado}
                    />
                  ))
                ) : (
                  <div className="admin-user-card">No hay usuarios creados desde el panel.</div>
                )}
              </div>
            ) : (
              <Table
                dataSource={usuariosAdmin}
                columns={adminColumns}
                rowKey="id"
                loading={loading}
                pagination={{ pageSize: 10 }}
                scroll={{ x: 'max-content' }}
                bordered
                locale={{ emptyText: 'No hay usuarios creados desde el panel.' }}
              />
            ),
          },
          {
            key: 'self',
            label: `Creados por cuenta propia (${usuariosSelf.length})`,
            children: isMobile ? (
              <div className="admin-mobile-list">
                {usuariosSelf.length ? (
                  usuariosSelf.map((user) => (
                    <UserCard
                      key={user.id}
                      user={user}
                      isAdminSection={false}
                      onToggleStatus={actualizarEstado}
                    />
                  ))
                ) : (
                  <div className="admin-user-card">No hay usuarios autoregistrados.</div>
                )}
              </div>
            ) : (
              <Table
                dataSource={usuariosSelf}
                columns={columns}
                rowKey="id"
                loading={loading}
                pagination={{ pageSize: 10 }}
                scroll={{ x: 'max-content' }}
                bordered
                locale={{ emptyText: 'No hay usuarios autoregistrados.' }}
              />
            ),
          },
        ]}
      />

      <RegisterFreeUser
        open={registerModalOpen}
        onClose={() => setRegisterModalOpen(false)}
        onSuccess={() => {
          fetchUsuarios();
          setRegisterModalOpen(false);
        }}
      />
    </div>
  );
};

export default Usuarios;
